<template>
  <div>
    <panel title="Informações do Produto">
      <div class="l-row">
        <form-group :label="$t('title.label')" :columns="6" :error="getErrorByProductId('title', product.productId)">
          <input class="form-input" type="text" v-model="product.title">
        </form-group>

        <form-group label="Descrição" :columns="12" slot="product"
                    :error="getErrorByProductId('description', product.productId)" :required="true">
          <quill-editor :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } "
                        v-model="product.description"/>
        </form-group>
      </div>
    </panel>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import { mapGetters } from 'vuex'
  import { quillEditor } from 'vue-quill-editor'

  export default {
    data: () => ({
      addingImage: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatProduct () {
        return this.product
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getErrorByProductId'
      ])
    },
    components: {
      Panel,
      FormGroup,
      quillEditor
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-bottom: 10px

  .c-box__body
    border-color: #bde2fb

  .check-box
    border-color: #7872ff

  .c-modalCard__body
    overflow: visible
</style>



// WEBPACK FOOTER //
// Product.vue?7f97726e